import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import MESSAGES from '../messages';

import CookieTabAccordionList from './CookieModules/CookieTabAccordionList/CookieTabAccordionList';

import './CookieContent.scss';

const CookieContent = ({showConfigOptions, handleActiveCookie, activeCookie}) => {
  return showConfigOptions ? (
    <CookieTabAccordionList handleActiveCookie={handleActiveCookie} activeCookie={activeCookie} />
  ) : (
    <p className="CookieContent__paragraph">
      <FormattedMessage
        {...MESSAGES.DESCRIPTION_MSG}
        values={{
          // eslint-disable-next-line react/no-unstable-nested-components
          a: (chunks) => (
            <a href="/legal/?section=cn" target="_blank" className="CookieContent__link" tabIndex={-1}>
              {chunks}
            </a>
          ),
        }}
      />
    </p>
  );
};

CookieContent.displayName = 'CookieModalBody';

CookieContent.propTypes = {
  /**
   * Set modal content.
   */
  showConfigOptions: PropTypes.bool,

  /**
   * Set each cookie consent in object.
   */
  handleActiveCookie: PropTypes.func,

  /**
   * Object with defautl params of each cookie
   */
  activeCookie: PropTypes.object,
};
export default CookieContent;
